document.addEventListener("DOMContentLoaded", function () {
  const cards = document.querySelectorAll(".about-card");

  if (cards.length > 0) {
    cards.forEach(card => {
      card.addEventListener("click", () => {
        cards.forEach(c => c.classList.remove("is-active"));
        card.classList.add("is-active");
      });
    });
  }
});
